/**
 * @module ChartSettingsPanel/GroupComponentWrapper
 * @description 按 groupId 从 groupRegistry 查找并渲染配置组组件
 */

import React from 'react';
import { groupRegistry } from '../manifest/groupRegistry';

const GroupComponentWrapper: React.FC<{
  groupId: string;
  visibleItems?: Record<string, boolean>;
}> = React.memo(({ groupId, visibleItems }) => {
  const Comp = groupRegistry[groupId];

  if (!Comp) {
    return null;
  }

  return (
    <div data-group-id={groupId} data-chart-settings-group={groupId}>
      <Comp visibleItems={visibleItems} />
    </div>
  );
});
GroupComponentWrapper.displayName = 'GroupComponentWrapper';

export default GroupComponentWrapper;
